<template>
  <div>
    <b-overlay
      :show="isPending"
    >
      <HeaderProductDetail
        v-if="product.is_complete"
        :data="product"
      />
    </b-overlay>

    <b-overlay
      :show="isPending"
    >
      <form-wizard
        v-if="!isPending"
        ref="formWizard"
        color="#7367F0"
        :title="null"
        :subtitle="null"
        class="mb-3"
        :start-index="startIndex"
      >
        <!-- Informasi Produk Tab -->
        <tab-content
          title="Informasi Produk"
        >
          <ProductInfoForm
            ref="ProductInfoForm"
            :form="form"
            :is-edit="isEdit"
          />
        </tab-content>

        <!-- Variant Tab -->
        <tab-content
          title="Varian"
        >
          <b-alert
            variant="primary"
            show
            class="mb-2"
          >
            <div class="alert-body d-flex align-items-center justify-content-between p-50">
              <div>
                <h5 class="mb-0 text-primary">
                  Varian Produk
                </h5>
                <small>Tambahkan Varian Produk Seperti Ukuran, Warna dll.</small>
              </div>

              <b-button
                v-if="!form.with_variant"
                variant="outline-primary"
                @click.prevent="form.with_variant = true"
              >
                Tambah Variant
              </b-button>
              <b-button
                v-else
                variant="outline-primary"
                @click.prevent="onDeleteAllVariant"
              >
                Hapus Variant
              </b-button>
            </div>
          </b-alert>
          <ProductVariantTable
            v-show="form.with_variant"
            ref="ProductVariantTable"
            :form="form"
            :variants-data="form.variants"
            :is-edit="isEdit"
            @updateVariants="onUpdateVariants"
          />
          <ProductVariantForm
            v-show="!form.with_variant"
            ref="ProductVariantForm"
            :form="form"
            :is-edit="isEdit"
          />
        </tab-content>

        <!-- Rekomendasi Untuk -->
        <tab-content
          title="Rekomendasi"
        >
          <ProductRecomendationForm
            ref="ProductRecomendationForm"
            :form="form"
            :is-edit="isEdit"
          />
        </tab-content>

        <!-- Footer -->
        <template
          slot="footer"
          slot-scope="props"
        >
          <div class="wizard-footer-left">
            <wizard-button
              v-if="props.activeTabIndex > 0"
              :style="props.fillButtonStyle"
              @click.native="props.prevTab()"
            >
              Kembali
            </wizard-button>
          </div>
          <div class="wizard-footer-right">
            <!-- step 1 -->
            <wizard-button
              v-if="props.activeTabIndex === 0"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
              :disabled="isSubmitting"
              @click.native="validateInfo"
            >
              <b-spinner
                v-if="isSubmitting"
                small
              />
              Simpan dan Lanjutkan
            </wizard-button>
            <!-- step 2 -->
            <wizard-button
              v-else-if="props.activeTabIndex === 1"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
              :disabled="isSubmitting || isInvalidPrice"
              @click.native="validateVariant"
            >
              <b-spinner
                v-if="isSubmitting"
                small
              />
              Simpan dan Lanjutkan
            </wizard-button>
            <!-- step 3 -->
            <wizard-button
              v-else-if="props.activeTabIndex === 2"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
              :disabled="isSubmitting"
              @click.native="validateRecomendation"
            >
              <b-spinner
                v-if="isSubmitting"
                small
              />
              Selesai
            </wizard-button>
          </div>
        </template>
      </form-wizard>
    </b-overlay>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

// bootstrap vue
import {
  BOverlay, BSpinner, BAlert, BButton,
} from 'bootstrap-vue'

// form wizard
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Ripple from 'vue-ripple-directive'

// components
import ProductInfoForm from '@/layouts/components/form/ProductInfoForm.vue'
import ProductVariantForm from '@/layouts/components/form/ProductVariantForm.vue'
import ProductVariantTable from '@/layouts/components/form/ProductVariantTable.vue'
import ProductRecomendationForm from '@/layouts/components/form/ProductRecomendationForm.vue'
import HeaderProductDetail from '@/layouts/components/form/HeaderProductDetail.vue'

export default {
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    ProductInfoForm,
    ProductVariantForm,
    ProductVariantTable,
    ProductRecomendationForm,
    HeaderProductDetail,
    BSpinner,
    BAlert,
    BButton,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        // step 1
        images: [],
        imagesFile: [],
        imagesId: [],

        merchant: null,
        name: null,
        keyword: null,
        description: null,
        category: null,
        condition: 'New',
        is_active: true,
        is_registry_only: false,
        preorder_days: null,
        // step 2
        sku_name: null,
        originalPrice: null,
        discountedPrice: null,
        weight: null,
        stock: null,
        idSku: null,
        // minimum_order: null,
        with_variant: false,
        variants: [],
        can_edit_price: true, // Default to true

        // step 3
        gender: null,
        min_age: null,
        max_age: null,

        // container
        attributes: [],

      },
      isPending: false,
      isSubmitting: false,
      isComplete: false,
    }
  },
  computed: {
    ...mapState('products', ['product', 'startIndex']),
    ...mapGetters('products', ['productStep']),
    isInvalidPrice() {
      if (!this.form.with_variant) {
        return !!(this.form.discountedPrice && this.form.originalPrice && Number(this.form.discountedPrice) >= Number(this.form.originalPrice))
      }
      // For product with variant
      if (this.form.variants && this.form.variants.length > 0) {
        return this.form.variants.some(v => v.discountedPrice && v.originalPrice && Number(v.discountedPrice) >= Number(v.originalPrice))
      }
      return false
    },
    productId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  async created() {
    if (this.isEdit) {
      this.isPending = true
      await this.getProduct(this.productId)
        .then(() => {
          this.fillData()
          this.$store.commit('products/SET_START_INDEX', 1)
          this.isPending = false
        })
        .catch(() => {
          this.isPending = false
        })

      if (this.startIndex === 2 || this.startIndex === 0) {
        this.$refs.formWizard.activateAll()
      }

      //   commit('SET_START_INDEX', 0)
    } else {
      this.$store.commit('products/SET_START_INDEX', 0)
    }
  },
  methods: {
    ...mapActions('products', ['createProduct', 'updateProductInfo', 'uploadImage', 'getProduct', 'updateProductVariant', 'updateProductRecomendation']),
    ...mapActions('brand', ['getBrandList']),
    ...mapActions('category', ['getCategoryList']),
    validateInfo() {
      this.isSubmitting = true
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const data = this.$refs.ProductInfoForm.validationForm()
          data.then(success => {
            if (success) {
              resolve(true)
              this.handleSubmitInfo()
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(true)
              this.isSubmitting = false
            }
          })
        }, 1000)
      })
    },
    validateVariant() {
      this.isSubmitting = true
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          let data
          if (this.form.with_variant) {
            data = this.$refs.ProductVariantTable.validationForm()
          } else {
            data = this.$refs.ProductVariantForm.validationForm()
          }
          data.then(success => {
            if (success) {
              resolve(true)

              const datas = {
                with_variant: this.form.with_variant ? 1 : 0,
                sku_name: this.form.sku_name,
                originalPrice: this.form.originalPrice,
                discountedPrice: this.form.discountedPrice,
                weight: this.form.weight,
                stock: this.form.stock,
                minimum_order: this.form.minimum_order,
                variants: this.form.variants,
                preorder_days: this.form.preorder_days,
              }
              if (this.form.idSku) {
                datas.id = this.form.idSku
              }

              this.updateProductVariant({
                data: datas,
                id: this.productId,
              })
                .then(async res => {
                  this.isSubmitting = await false
                  if (!res.data.is_complete) this.$refs.formWizard.nextTab()
                }).catch(() => {
                  this.isSubmitting = false
                })
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(true)
              this.isSubmitting = false
            }
          })
        }, 1000)
      })
    },
    validateRecomendation() {
      this.isSubmitting = true
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const data = this.$refs.ProductRecomendationForm.validationForm()
          data.then(success => {
            if (success) {
              resolve(true)
              this.updateProductRecomendation({
                data: {
                  gender: this.form.gender,
                  min_age: this.form.min_age,
                  max_age: this.form.max_age,
                },
                id: this.productId,
                isEdit: this.isComplete,
              })
                .then(() => {
                  this.isSubmitting = false
                  if (!this.isComplete) this.$router.push('/products')
                })
                .catch(() => {
                  this.isSubmitting = false
                })
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(true)
              this.isSubmitting = false
            }
          })
        }, 1000)
      })
    },
    onUpdateVariants(value) {
      this.form.variants = value
    },
    onDeleteAllVariant() {
      const defaultSku = this.form.variants.find(variant => variant.default_sku) || this.form.variants[0]

      if (defaultSku) {
        this.form.idSku = defaultSku.id
        this.form.sku_name = defaultSku.sku_name
        this.form.originalPrice = defaultSku.originalPrice
        this.form.discountedPrice = defaultSku.discountedPrice
        this.form.weight = defaultSku.weight
        this.form.stock = defaultSku.stock
        this.form.minimum_order = defaultSku.minimum_order
        this.form.preorder_days = defaultSku.preorder_days
        this.form.can_edit_price = defaultSku.can_edit_price !== false
      }

      this.form.with_variant = false
      this.form.variants = []
      this.$refs.ProductVariantTable.removeAllVariant()
    },
    // NOTE submit methods
    async handleSubmitInfo() {
      this.isSubmitting = true

      const imageId = this.form.images.map(el => el.id)
      this.form.imagesId = imageId

      await this.createProduct({ id: this.isEdit ? this.productId : null, data: this.form })
        .then(res => {
          this.isSubmitting = false
          this.$router.push(`/products/${res.data.id}/edit`)
        }).catch(() => {
          this.isSubmitting = false
        })

      this.isSubmitting = false
    },
    // edit state only
    fillData() {
      // step 1
      this.form.merchant = this.product.merchant
      this.form.images = this.product.images
      this.form.name = this.product.name
      this.form.keyword = this.product.keyword
      this.form.category = this.product.category
      this.form.is_active = this.product.is_active
      this.form.condition = this.product.condition
      this.form.description = this.product.description
      this.form.require_delivery_insurance = this.product.require_delivery_insurance
      this.form.is_registry_only = this.$store.state.auth.userData.role !== 'admin' ? false : this.product.is_registry_only
      this.form.preorder_days = this.product.preorder_days || null
      // step 2
      if (this.product.variants.length && this.product.variants[0].variant === '') {
        this.form.sku_name = this.product.variants[0].sku_name
        this.form.weight = this.product.variants[0].weight
        this.form.stock = this.product.variants[0].stock
        this.form.minimum_order = this.product.variants[0].minimum_order
        this.form.with_variant = false
        this.form.idSku = this.product.defaultSku.id
        this.form.can_edit_price = this.product.variants[0].can_edit_price !== false // Copy can_edit_price

        this.form.originalPrice = this.product.variants[0].originalPrice
        this.form.discountedPrice = this.product.variants[0].discountedPrice
      }
      if (this.product.variants.length && this.product.variants[0].variant !== '') {
        this.form.with_variant = true
        this.form.variants = this.product.variants
        this.form.with_variant = true
      }
      // step 3
      this.form.gender = this.product.gender
      this.form.min_age = this.product.min_age
      this.form.max_age = this.product.max_age
      this.isComplete = this.product.is_complete
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/quill.scss';
</style>

<style lang="scss" scoped>
::v-deep .vs__actions {
    .vs__clear {
        visibility: hidden;
    }
}
</style>
